/**
 * Date Time Utils
 */
import moment from "moment";

export const formatApiDate = (date, format = "M/DD/YYYY") => {
  return moment(date).format(format);
};
